import {Directive, ElementRef, HostListener, Input} from '@angular/core';

@Directive({
    standalone: true,
    selector: '[maxLengthInputLimit]'
})
export class MaxLengthInputLimitDirective {
    @Input('maxLengthInputLimit') maxLength: number;
    constructor(private el: ElementRef) {}

    @HostListener('input') onInputChange(): void {
        const input = this.el.nativeElement as HTMLInputElement;
        if (input.value.length > this.maxLength) {
            input.value = input.value.slice(0, this.maxLength);
        }
    }
}
